import { OrderBaseView } from "../../../order/base";
import { Template } from "../../../../../../core/template/index";
import { FortumApp } from "../../../../../fortumApp";
import { View } from "../../../../../../core/view/index";
import { OrderLike, Order } from "../../../../../db/models/decontamination/order";
import { OrderItemLike } from "../../../../../db/models/decontamination/orderItem";
import { OrderDetailViewData } from "../../detail/index";

export default class OrderDetailTabView extends View
{
    public template = Template.lazy('/app/views/decontamination/order/tab/detail/index.html');
    public app: FortumApp;
    public data: OrderDetailTabViewData;

    constructor(data?: OrderDetailTabViewData) 
    {
        super(data);
    }

    public beforeRender(): PromiseLike<void>
    {        
        this.data.priorityLabels = {
            [Order.PRIORITY_NORMAL]: this.pgettext('decontamination.Order.priority', 'Normal'),
            [Order.PRIORITY_HIGHEST]: this.pgettext('decontamination.Order.priority', 'Highest'),
        };     
        this.data.stateLabels = {
            [Order.STATE_NEW]: this.pgettext('decontamination.Order.state', 'New'),
            [Order.STATE_STARTED]: this.pgettext('decontamination.Order.state', 'Started'),
            [Order.STATE_COMPLETED]: this.pgettext('decontamination.Order.state', 'Completed'),
        };
        return super.beforeRender();
    }

    public afterRender(): PromiseLike<void>
    {        
        console.log(this.data)
        return super.afterRender();
    }
}

export interface OrderDetailTabViewData extends  OrderDetailViewData
{
    priorityLabels?: {[key: string]: string};
    stateLabels?: {[key: string]: string};
}